import { apiNameReverseMap } from '../api/api';
import { MockContext } from '../components/mock-provider/MockProvider';
import { useCallback, useContext, useEffect, useState } from 'react';

export const useApi = ({
  requestFn,
  skipInitialCall = false,
  args = [],
  onError,
  onSuccess,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const { isApiMocked, callMockApi } = useContext(MockContext) ?? {};

  useEffect(() => {
    if (!skipInitialCall) {
      call();
    }
  }, [skipInitialCall]);

  const call = useCallback(async (...callArgs) => {
    const requestFnName = apiNameReverseMap.get(requestFn);
    const useMocks = isApiMocked?.(requestFnName);

    if (useMocks) {
      const resp = await callMockApi?.(requestFnName);
      onSuccess?.(resp);
      setData(resp);
      return resp;
    }

    const finalArgs = callArgs.length ? callArgs : args;

    try {
      setIsLoading(true);
      const resp = await requestFn(...finalArgs);
      setData(resp);
      onSuccess?.(resp);
      return resp;
    } catch (e) {
      setError(e);
      onError?.(e);

      if (!onError) {
        throw e;
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    data,
    error,
    call,
  };
};
